import type { SynastryDTO, SynastryListResponse } from '@/api/schema'
import { Row } from '@/app/components/Flex/Flex'
import { Layout } from '@/app/components/Layout/Layout'
import { Loader } from '@/app/components/Loader/Loader'
import { MenuFooter } from '@/app/components/MenuFooter/MenuFooter'
import { Motion } from '@/app/components/Motion/Motion'
import { Lib } from '@/app/components/UI/Lib'
import { UI } from '@/app/components/UI/UI'
import { useBack } from '@/app/hooks/useBack'
import { SynastryItem } from '@/app/pages/SynastryPage/SynastryList/Item'
import { useSession } from '@/app/state/session'
import { api } from '@/app/utils/api'
import { parseError } from '@/app/utils/error'
import type { FunctionalComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'

export const SynastryList: FunctionalComponent = () => {
  const synastriesCount = useSession(s => s.user?.synastriesCount)

  const [ready, setReady] = useState(false)
  const [synastries, setSynastries] = useState<SynastryDTO[]>([])
  const [errors, setErrors] = useState<string[]>([])

  const back = useBack('~/tools')

  useEffect(() => {
    api.get<SynastryListResponse>('/synastry')
      .then(resp => {
        setSynastries(resp.data.synastries)
      })
      .catch(e => {
        console.error(e)
        setErrors(parseError(e))
      })
      .finally(() => {
        setReady(true)
      })
  }, [])

  return (
    <Layout>
      <Layout.Content
        onBack={back}
      >
        <Row gap={15} flexGrow={1}>
          {!ready
            ? (
              <Loader.Container>
                <Loader type='synastry' />
              </Loader.Container>
            )
            : (
              <Motion>
                <Layout.Header>
                  Совместимость
                </Layout.Header>

                <Row gap={15}>
                  {synastries.length > 0
                    ? (
                      <Row gap={10}>
                        {synastries.map(item => <SynastryItem item={item} />)}
                      </Row>
                    )
                    : (
                      <Lib.SystemMessage>
                        Узнай, насколько вы подходите друг другу по натальной карте или матрице судьбы.
                      </Lib.SystemMessage>
                    )}

                  <Lib.Errors errors={errors} />

                  <UI.Button
                    type='primary'
                    size='l'
                    link='/create'
                    disabled={!ready || synastriesCount === undefined}
                  >
                    Добавить партнёра
                  </UI.Button>
                </Row>
              </Motion>
            )}
        </Row>

        <MenuFooter />
      </Layout.Content>
    </Layout>
  )
}
